import 'maplibre-gl/dist/maplibre-gl.css'

import './styles/theme.css'
import './styles/app.css'
import './styles/shell.css'
import './styles/panels.css'

import { VeloGpxApp } from './app'

/**
 * Point d'entrée.
 *
 * Se limite à récupérer les éléments du document, démarrer l'application et
 * afficher un écran d'erreur lisible si le démarrage échoue — un écran de
 * chargement figé n'apprendrait rien à l'utilisateur.
 */
async function boot(): Promise<void> {
  const app = document.getElementById('app')
  const map = document.getElementById('map')
  const overlays = document.getElementById('overlays')
  const splash = document.getElementById('splash')

  if (!app || !map || !overlays) {
    throw new Error('Structure HTML inattendue : #app, #map ou #overlays manquant.')
  }

  const instance = new VeloGpxApp(app, map, overlays)
  await instance.start()

  if (splash) {
    splash.dataset.leaving = 'true'
    window.setTimeout(() => splash.remove(), 300)
  }

  registerServiceWorker()
}

function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) {
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch((error: unknown) => {
      // L'absence de service worker n'empêche que le fonctionnement hors
      // ligne : l'application reste utilisable.
      console.warn('[VeloGPX] Service worker non enregistré', error)
    })
  })
}

function showFatalError(error: unknown): void {
  document.getElementById('splash')?.remove()

  const detail =
    error instanceof Error ? error.message : String(error ?? 'Erreur inconnue')

  const panel = document.createElement('div')
  panel.className = 'fatal'
  panel.setAttribute('role', 'alert')

  const title = document.createElement('h1')
  title.className = 'fatal__title'
  title.textContent = 'VeloGPX n’a pas pu démarrer'

  const message = document.createElement('p')
  message.className = 'fatal__detail'
  message.textContent = detail

  panel.append(title, message)
  document.body.append(panel)

  console.error('[VeloGPX] Échec du démarrage', error)
}

boot().catch(showFatalError)
